import ProjectList from "./ProjectList";
import { useMemo, useState } from "react";
import ProjectTypeFilter from "~/components/filters/ProjectTypeFilter";
import SortDropdown from "~/components/filters/SortDropdown";

interface FilteredProjectListProps {
  projects: any[];
  isEmbedded?: boolean;
  theme?: string;
  projectCardLocation: string;
  headingCopy?: string;
  typeFilter?: boolean;
  sortDropdown?: boolean;
  headingType?: string;
  subHeadingCopy?: string;
  refPageSlug?: string;
  refPageType: string;
  refPageLabel: string;
}

const FilteredProjectList: React.FC<FilteredProjectListProps> = ({
  projects,
  isEmbedded,
  theme,
  projectCardLocation,
  headingCopy,
  typeFilter,
  sortDropdown,
  headingType,
  subHeadingCopy,
  refPageType,
  refPageSlug,
  refPageLabel,
}) => {
  const [selectedType, setSelectedType] = useState("All");
  const [selectedSort, setSelectedSort] = useState("Most Recent");

  const filteredProjects = useMemo(() => {
    let filtered = projects;

    if (selectedType !== "All") {
      filtered = filtered.filter((project) => project.type === selectedType);
    }

    if (selectedSort === "Oldest") {
      filtered = filtered.sort(
        (a, b) => +new Date(a.completed) - +new Date(b.completed)
      );
    } else if (selectedSort === "Most Recent") {
      filtered = filtered.sort(
        (a, b) => +new Date(b.completed) - +new Date(a.completed)
      );
    }

    return filtered;
  }, [projects, selectedType, selectedSort]);

  return (
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col justify-center  border-b lg:flex-row lg:items-end lg:justify-between">
        <div>
          {headingCopy === null || projects.length === 0 ? null : (
            <h2
              className={`mb-0 mt-2 flex justify-center pb-0 font-semibold text-gray-900 lg:mt-0 lg:mb-1 lg:justify-start ${
                headingType === "h1" ? "text-4xl" : "text-3xl"
              }`}
            >
              {headingCopy}
            </h2>
          )}
          {subHeadingCopy ? <p className="mb-1">{subHeadingCopy}</p> : null}
        </div>
        <div className="mb-2 mt-3 flex justify-center lg:ml-10 lg:mt-0 lg:justify-end">
          {typeFilter === true ? (
            <ProjectTypeFilter
              projects={projects}
              selectedType={selectedType}
              onTypeChange={setSelectedType}
            />
          ) : null}
          {sortDropdown === true ? (
            <SortDropdown
              selectedSort={selectedSort}
              onSortChange={setSelectedSort}
            />
          ) : null}
        </div>
      </div>

      <ProjectList
        projects={filteredProjects}
        selectedType={selectedType}
        isEmbedded={isEmbedded}
        theme={theme}
        refPageSlug={refPageSlug}
        refPageType={refPageType}
        refPageLabel={refPageLabel}
        projectCardLocation={projectCardLocation}
      />
    </div>
  );
};

export default FilteredProjectList;
